const fontColors = {
  title: '#292929',
  subtitle: '#666666',
};

export default fontColors;
